import React, { useContext, useEffect } from 'react';
import { ProgressIndicator } from '@fluentui/react';

import { Fail } from 'components/common/Fail';
import { useEnvironmentCheckInfo } from 'hooks/api';
import { Title } from 'components/common/Title';
import { ApiError } from 'services/restService';
import { promptBeforeUnloadListener } from 'utils/browser';
import { StepProps } from 'components/environmentcheck/EnvironmentCheck';
import { WarningMessage } from 'components/common/WarningMessage';
import { stepStyles as styles } from 'components/steps/commonStyles';
import { StepContainer } from 'components/common/steps/StepContainer';
import TranslationsContext from 'translations/TranslationsContext';
import translationsProvider from 'translations/translationsProvider';
import translationKeys from 'translationKeys';

export const GatherInformation = ({stepRef, checkCanGoNext, environmentCheck, setStepError, goToNextStep, environmentCheckResult }: StepProps) => {
	const { t } = useContext(TranslationsContext)!;
	const [settingsInfo] = useEnvironmentCheckInfo(environmentCheck);
	const { error, isLoading } = settingsInfo;

	useEffect(() => {
		if (error) {
			setStepError(error);
		} else {
			const unsubscribe = promptBeforeUnloadListener();
			return unsubscribe;
		}
	}, [error]);

	useEffect(() => {
		if(!!settingsInfo.environmentCheckResult){
			stepRef.current.getDatafromStep = () => Promise.resolve({ environmentCheckResult: settingsInfo.environmentCheckResult });
		}
	}, [settingsInfo]);

	useEffect(() => {
		if (!isLoading && !error) {
			goToNextStep();
		}
	}, [isLoading, error]);

	useEffect(() => {
		checkCanGoNext(false);
	}, []);

	if (error) return renderFail(error);

	return (
		<StepContainer className={styles.root}>
			<Title>{t(translationKeys.GatherInformation.Step.Default.Title)}</Title>
			<p className={styles.formElement}>{t(translationKeys.GatherInformation.Step.Default.Paragraph)}</p>
			<WarningMessage>{t(translationKeys.GatherInformation.Step.Default.WarningMessage)}</WarningMessage>
			<div className={styles.line} />
			<ProgressIndicator className={styles.progress} label={t(translationKeys.GatherInformation.Default.ProgressIndicator.Label)} />
		</StepContainer>
	);
};

const renderFail = (error: ApiError) => (
	<StepContainer className={styles.root}>
		<Fail
			className={styles.stretchedContainer}
			error={error}
			title={translationsProvider.staticTranslate(translationKeys.GatherInformation.Step.Fail.Title)}
			detail={translationsProvider.staticTranslate(translationKeys.GatherInformation.Step.Fail.Detail)}
		/>
	</StepContainer>
);
